<template>
  <div>
    <v-card
      outlined
      v-for="(doc, index) in status"
      :key="index"
      :class="['legend-container mt-2', doc.class]"
      >
      <v-row class="ml-15">
        <v-col sm="2">
          <h4>{{ $t('modules.portalalumno.admission.documentation.status') }}</h4>
        </v-col>
        <v-col>
          <div class="ml-n5" :class="doc.class">
            <h5>
                <v-icon :class="['icon_legend mr-3', doc.class]">{{ doc?.icon }}</v-icon>
                {{ doc?.meaning + ' / ' + doc?.text }}
            </h5>
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-n6 ml-15">
        <v-col sm="2" >
          <h4>{{ $t('modules.portalalumno.admission.documentation.observation') }}</h4>
        </v-col>
        <v-col  class="ml-6">
          <h5 v-if="doc.id == 96">{{ $t('modules.portalalumno.admission.documentation.pending') }}</h5>
          <h5 v-else >{{ doc?.commentary || 'Sin observaciones' }}</h5>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>


<script>
  export default {
    name: 'DocumentLegend',
    props: {
      documentationUploaded: Array,
    },
    computed: {
      status() {
        const states = [];
        if (!Array.isArray(this.documentationUploaded) || (this.documentationUploaded.length === 0)) {
          return states;
        }
        const latestDocs = this.documentationUploaded?.reduce((acc, doc) => {
          const key = doc.documentation.id === 46
          ? doc.documentation.documentationSubtype.id
          : doc.documentation.id
          acc[key] = doc;
          return acc;
        }, {});
        Object.values(latestDocs)?.forEach(doc => {
          if (!doc || !doc.docStatus) return;
          let state = {};
          switch (doc.docStatus.value) {
            case 258:
              state = {
                id: doc.docStatus.value,
                class: 'review-case',
                icon: 'mdi-progress-clock',
                meaning: doc.documentation.name,
                text: doc.docStatus.meaning,
                commentary: doc.commentary
              };
              break;
            case 95:
              state = {
                id: doc.docStatus.value,
                class: 'denied-case',
                icon: 'mdi-close-circle',
                meaning: doc.documentation.name,
                text: doc.docStatus.meaning,
                commentary: doc.commentary
              };
              break;
            case 94:
              state = {
                id: doc.docStatus.value,
                class: 'success-case',
                icon: 'mdi-check-circle-outline',
                meaning: doc.documentation.name,
                text: doc.docStatus.meaning,
                commentary: doc.commentary
              };
              break;
            case 96:
              state = {
                id: doc.docStatus.value,
                class: 'pending-case',
                icon: 'mdi-pencil-circle',
                meaning: doc.documentation.name,
                text: doc.docStatus.meaning,
                commentary: doc.commentary
              };
              break;
            default:
              state = { isNew: false, class: 'unknown', icon: '', text: 'Desconocido', commentary: doc.commentary };
          }
          states.push(state);
        });
        return states;
      },
    }
  }
</script>

<style lang="sass" scoped>
@mixin font ($size, $weight: normal, $color: black, $align)
  font-size: $size
  font-weight: $weight
  color: $color
  text-align: $align
@mixin display ($display: null, $align: null)
  display: $display
  align-items: $align
@mixin icon ($size: 20px, $padding: 0px, $border: 50%)
  font-size: $size
  padding: $padding
  border-radius: $border
.legend-container
  @include display (grid)
  border: none
  border-radius: 8px
  &.success-case
    background-color: #EAF5EA
  &.denied-case
    background-color: #FFF1E0
  &.pending-case
    background-color: #FFF1E0
  &.review-case
    background-color: #E0EBFF
  h4
    @include font (15px, glob, null, left)
  h5
    @include font (14px, normal, gray, null)
    padding-left: 3%
  .icon_legend
    @include icon (null)
    &.success-case
      color: green
    &.denied-case
      color: red
    &.pending-case
      color: #FB8C00
    &.review-case
      @include icon(17px, 2px, null)
      background-color: #3D6CD9
      color: white
</style>
